
/**
 * function to disable quantity input
 * logic if the line item is custom roll size
 */

function hideCustomRollQuantity() {
  var cartItems = document.querySelectorAll('cart-items li')
  cartItems.forEach(function (cartItem) {
    var productOptions = cartItem.querySelectorAll('.product-option')
    console.log('im in mini cart 1')
    productOptions.forEach(function (option) {
      var optionName = option.innerText
      console.log('im in mini cart 2', optionName, optionName.includes('Custom'))
      if (optionName.includes('Custom')) {
        console.log('im in mini cart 3')

        console.log('im in mini cart 4')
        var quantityInput = cartItem.querySelector('quantity-input')
        if (quantityInput) {
          console.log('im in mini cart 5', quantityInput)
          var buttonsToDisable = quantityInput.querySelectorAll('button')
          var inputsToDisable = quantityInput.querySelectorAll('input')
          buttonsToDisable.forEach(function (buttonElement) { buttonElement.disabled = true })
          inputsToDisable.forEach(function (inputElement) { inputElement.disabled = true })
          quantityInput.classList.add('mini-custom')
        }
      }
    })
  })

}


document.addEventListener("DOMContentLoaded", function () {
  var miniCart = document.querySelector('mini-cart')
  if (miniCart) {
    console.log('im in cart observer')
    var observer = new MutationObserver(function (mutations) {
      window.hideCustomRollQuantity()
    })
    observer.observe(miniCart, { attributes: false, childList: true, characterData: false, subtree: true })
  }
})